module.exports = __webpack_public_path__ + "f049a1d32cb0b227bb158dec4e084d88.pdf";